import React, { Fragment, useContext } from 'react'
import styled from 'styled-components'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Badge from 'react-bootstrap/Badge'
import { JazeelContext } from '../../../../utils/JazeelContext'
import Moment from 'react-moment'
const NameBadge = styled(Badge)`
  padding: 0.7em;
  background-color: rgb(113, 212, 131);
  margin-right: 0.3em;
`
const ActivityBadge = styled(Badge)`
  font-size: 60%;
`
function displayActivites(activites) {
  return Object.keys(activites).map((key, index) => (
    <Fragment key={index}>
      <p className="text-muted mb-1">
        <Moment format="D MMM YYYY">{key}</Moment>
      </p>
      {activites[key].map((activity, index) => (
        <Row key={index}>
          <div className="col-auto text-center flex-column d-none d-sm-flex">
            <h5 className="m-2">
              <ActivityBadge
                className={
                  'badge-pill ' +
                  (activity.type === 'plus' ? 'bg-success' : 'bg-danger')
                }
              >
                &nbsp;
              </ActivityBadge>
            </h5>
            <Row className="h-50">
              <Col className="border-right">&nbsp;</Col>
              <Col>&nbsp;</Col>
            </Row>
          </div>
          <Col className="py-2">
            <div>
              <div className="float-right text-muted">
                <Moment format="HH:mm A">{activity.created_at}</Moment>
              </div>
              <p>
                <NameBadge variant="info">You</NameBadge>
                {activity.type === 'plus' ? 'got' : 'withdrawn'}{' '}
                {activity.points} point by {activity.name} on{' '}
                <a href={activity.brand.Url} className="text-info">
                  {activity.brand.Name}
                </a>
              </p>
            </div>
          </Col>
        </Row>
      ))}
    </Fragment>
  ))
}
export default function Activites() {
  const { userData } = useContext(JazeelContext)
  return (
    <Fragment>
      {userData.activities.length <= 0 ? (
        <p className="text-center text-danger">
          You haven't any recent activites
        </p>
      ) : (
        <Container className="py-2 mt-4 mb-4">
          {displayActivites(userData.activities)}
        </Container>
      )}
    </Fragment>
  )
}
